/* =========================================================
   MANEWAY CART DRAWER
   - Cross-sell row: arrows + "Add" for quick-add products
   - Re-syncs the drawer when something else (an app, another
     tab of the theme) changes the cart
   Markup: snippets/cart-drawer.liquid. Dawn's cart-drawer.js and
   cart.js still handle opening, quantities and removing.
========================================================= */

(function () {
  var routes = window.routes || {};
  var cartUrl = routes.cart_url || '/cart';
  var addUrl = (routes.cart_add_url || '/cart/add') + '.js';

  function drawer() {
    return document.querySelector('cart-drawer.mw-cart');
  }

  /* ---------- Cross-sell arrows ---------- */

  function updateArrows(root) {
    (root || document).querySelectorAll('[data-mw-upsell]').forEach(function (box) {
      var track = box.querySelector('[data-mw-upsell-track]');
      var prev = box.querySelector('[data-mw-upsell-prev]');
      var next = box.querySelector('[data-mw-upsell-next]');
      if (!track || !prev || !next) return;
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    });
  }

  function slide(button, dir) {
    var track = button.closest('[data-mw-upsell]').querySelector('[data-mw-upsell-track]');
    var item = track.firstElementChild;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    var step = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  /* ---------- Quick add ---------- */

  function addUpsell(button) {
    var card = button.closest('.mw-cart__up');
    var box = button.closest('[data-mw-upsell]');
    var field = card && card.querySelector('[data-mw-upsell-variant]');
    var error = box && box.querySelector('[data-mw-upsell-error]');
    if (!field || !field.value) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(field.value), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (state) {
        if (state.status || !state.sections) {
          throw new Error(state.description || state.message || 'This item could not be added.');
        }
        var cart = drawer();
        if (cart && typeof cart.renderContents === 'function') {
          cart.classList.remove('is-empty');
          cart.renderContents(state);
        }
      })
      .catch(function (err) {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        if (error) {
          error.textContent = err.message;
          error.hidden = false;
        }
      });
  }

  /* ---------- Edit personalization ---------- */

  function propsMessage(box, text, ok) {
    var msg = box.querySelector('[data-mw-props-msg]');
    if (!msg) return;
    msg.textContent = text;
    msg.className = 'mw-cart__props-msg ' + (ok ? 'is-ok' : 'is-error');
  }

  function saveProps(button) {
    var box = button.closest('[data-mw-props]');
    var json = box.querySelector('[data-mw-props-json]');
    var properties = {};
    var raw = null;
    try { raw = JSON.parse(json.textContent); } catch (e) {}
    // Liquid serialises line item properties as [[name, value], ...]; /cart/change needs an object.
    if (Array.isArray(raw)) {
      raw.forEach(function (pair) {
        if (Array.isArray(pair) && pair.length >= 2) properties[pair[0]] = pair[1];
      });
    } else if (raw && typeof raw === 'object') {
      properties = raw;
    }

    var missing = null;
    box.querySelectorAll('[data-prop]').forEach(function (field) {
      var value = field.value.trim();
      if (!value && !missing) missing = field;
      properties[field.getAttribute('data-prop')] = value;
    });

    if (missing) {
      missing.focus();
      propsMessage(box, 'Please fill in every field.', false);
      return;
    }

    var index = box.closest('.cart-item') && box.closest('.cart-item').id;
    button.classList.add('is-loading');
    propsMessage(box, '', true);

    fetch((routes.cart_change_url || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: box.getAttribute('data-key'),
        quantity: Number(box.getAttribute('data-quantity')),
        properties: properties,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (state) {
        if (state.status || !state.sections) {
          throw new Error(state.description || state.message || 'Could not save. Please try again.');
        }
        var cart = drawer();
        if (cart && typeof cart.renderContents === 'function') cart.renderContents(state);

        // Confirm on the same line once the drawer has re-rendered.
        setTimeout(function () {
          var row = index && document.getElementById(index);
          var wrap = row && row.querySelector('[data-mw-props-wrap]');
          if (!wrap) return;
          var note = document.createElement('p');
          note.className = 'mw-cart__saved';
          note.setAttribute('role', 'status');
          note.textContent = 'Personalization updated';
          wrap.insertAdjacentElement('afterend', note);
          setTimeout(function () { note.remove(); }, 3000);
        }, 50);
      })
      .catch(function (err) {
        button.classList.remove('is-loading');
        propsMessage(box, err.message, false);
      });
  }

  // These fields live inside the checkout form: keep their events away from
  // Dawn's quantity handler, and don't let Enter submit the checkout.
  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('[data-mw-props]')) event.stopPropagation();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || event.target.tagName !== 'INPUT') return;
    var box = event.target.closest && event.target.closest('[data-mw-props]');
    if (!box) return;
    event.preventDefault();
    saveProps(box.querySelector('[data-mw-props-save]'));
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest || !target.closest('cart-drawer.mw-cart')) return;

    var save = target.closest('[data-mw-props-save]');
    if (save) { saveProps(save); return; }

    var cancel = target.closest('[data-mw-props-cancel]');
    if (cancel) {
      var wrap = cancel.closest('[data-mw-props-wrap]');
      var box = cancel.closest('[data-mw-props]');
      box.querySelectorAll('[data-prop]').forEach(function (field) { field.value = field.defaultValue; });
      propsMessage(box, '', true);
      if (wrap) wrap.open = false;
      return;
    }

    var prev = target.closest('[data-mw-upsell-prev]');
    if (prev) { slide(prev, -1); return; }

    var next = target.closest('[data-mw-upsell-next]');
    if (next) { slide(next, 1); return; }

    var add = target.closest('[data-mw-upsell-add]');
    if (add) { event.preventDefault(); addUpsell(add); }
  });

  document.addEventListener('scroll', function (event) {
    if (event.target.matches && event.target.matches('[data-mw-upsell-track]')) updateArrows(event.target.parentNode);
  }, true);

  /* ---------- Keep in sync with cart changes made elsewhere ---------- */

  var syncTimer = null;

  function sync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      var cart = drawer();
      var inner = cart && cart.querySelector('.drawer__inner');
      if (!inner) return;

      fetch(cartUrl + '?section_id=cart-drawer', { credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
          if (!fresh) return;
          var before = inner.getAttribute('data-mw-cart-sig') || '';
          var after = fresh.getAttribute('data-mw-cart-sig') || '';
          if (before === after) return;

          var countBefore = parseInt(before, 10) || 0;
          var countAfter = parseInt(after, 10) || 0;

          inner.innerHTML = fresh.innerHTML;
          inner.setAttribute('data-mw-cart-sig', after);
          cart.classList.toggle('is-empty', countAfter === 0);

          // Something outside the theme's own forms added to the cart: show it.
          if (countAfter > countBefore && !cart.classList.contains('active') && typeof cart.open === 'function') {
            cart.open();
          }
        })
        .catch(function () {});
    }, 400);
  }

  document.addEventListener('mw:cart-changed', sync);

  /* ---------- Product options app (BCPO) ---------- */

  // BCPO takes over Add to cart and then sends shoppers to /cart. Its
  // "bcpo:afterAdd" hook skips that redirect when a handler returns true,
  // so refresh and open the drawer instead.
  function openFreshDrawer() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (sections) {
        var cart = drawer();
        if (!cart || !sections || !sections['cart-drawer']) {
          window.location.href = cartUrl;
          return;
        }
        cart.classList.remove('is-empty');
        cart.renderContents({ sections: sections });
      })
      .catch(function () { window.location.href = cartUrl; });
  }

  function hookBcpo() {
    var app = window.bcpo;
    if (!app || !app.$) return false;
    if (!app.mwDrawerHooked) {
      app.mwDrawerHooked = true;
      app.$(document).on('bcpo:afterAdd', function () {
        if (!drawer()) return false; // no drawer: let BCPO go to the cart page
        openFreshDrawer();
        return true;
      });
    }
    return true;
  }

  if (!hookBcpo()) {
    var tries = 0;
    var poll = setInterval(function () {
      if (hookBcpo() || ++tries > 100) clearInterval(poll);
    }, 200);
  }

  // Browser back/forward cache can show a stale cart.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) sync();
  });

  function init() {
    var cart = drawer();
    if (!cart) return;
    updateArrows(cart);
    if (window.MutationObserver) {
      new MutationObserver(function () { updateArrows(cart); }).observe(cart, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
